import React from 'react'
import NavLink from '../Routes/NavLink'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import { workOrders } from '../../core/controllers/WorkOrders';
import { user } from '../../core/controllers/user';
import { modal } from '../../core/utilities/modal';

export default class TenantWorkOrdersList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workOrders: {},
            orderFilter: 'All',
            orderSort: props.sortOptions
        }

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        workOrders.getWorkOrdersForTenant(this.state.orderFilter, this.state.orderSort, function(response){
            if(response.data.length > 0) {
                self.setState({
                    workOrders: response.data
                });
            }
        });

        if(user.userInfo == null) {
            user.getUserDataWithCallback(function() {
                self.forceUpdate();
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        var self = this;

        this.index = 0;
        if(nextProps.orderFilter !== nextState.orderFilter) {
            nextState.orderFilter = nextProps.orderFilter;
            workOrders.getWorkOrders(nextState.orderFilter, this.state.orderSort, function(response){
                if(response.data.length > 0) {
                    self.setState({
                        workOrders: response.data
                    });
                }
            });
        }
    }

    componentDidUpdate() {

    }

    formatSubmittedDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

    simpleFormatSubmittedDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

    formatBuildingLink(cell, row) {
        if(cell !== null) {
            if(row.building_level != 0) {
                return <NavLink to={row.building_link}>{cell} - Level {row.building_level}</NavLink>
            } else {
                return <NavLink to={row.building_link}>{cell}</NavLink>
            }
        } else {
            return 'None';
        }
    }

    formatPropertyName(cell, row) {
        if(cell !== null) {
            return <NavLink to={"/properties/" + row.property_id}>{cell}</NavLink>
        } else {
            return 'None';
        }
    }

    formatContractorLink(cell, row) {
        if(row.assignee_id != "0" && row.assignee_data != null) {
            return <span class="contractor-info" onClick={modal.showSuccess.bind(modal, 'Contractor Information', 'Firstname: ' + row.assignee_data.firstname + '</br>Lastname: ' + row.assignee_data.lastname + '</br>Phone: ' + row.assignee_data.phone + '</br>Company: ' + row.assignee_data.company + '</br>Email: ' + row.assignee_data.email, <NavLink to={"/user/" + row.assignee_id} />, 'Edit User')}>
                        {row.assignee_data.company}
                   </span>
        } else {
            return 'Not Assigned';
        }
    }

    formatActionOptions(cell, row) {
        return <NavLink to={'/maintenance/order/' + row.work_order_id}><i class="fa fa-pencil-square-o"></i></NavLink>
    }

    clickableTitle(cell, row) {
        return <NavLink to={'/maintenance/order/' + row.work_order_id}>{row.work_order_title}</NavLink>
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLease(cell, row) {
        if(row.contract != null) {
            return <NavLink to={'/lease/' + row.contract.contract_id}>{row.contract_data.title}</NavLink>
        } else {
            return 'No Lease';
        }
    }

    render(){
        const workOrders = this.state.workOrders;
        const userType = user.userInfo ? user.userInfo.user_type_alias : null;
        var options = {
            defaultSortName: 'created_at',  // default sort column name
            defaultSortOrder: 'desc'  // default sort order
        };
        const isMobile = window.innerWidth < 992
        if (userType !== null && userType !== 'contractor' && this.props.tableType != 'widget') {
            if (userType === 'tenant' && this.props.tableType == 'dashboard') {
                return (
                    <div class="row">
                        <div class="content">
                        {workOrders.length > 0 ? (
                            <div>
                                <BootstrapTable data={workOrders} version='4' options={options} striped search pagination>
                                    <TableHeaderColumn dataField='id' hidden={isMobile} width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true } />
                                    <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                                    <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Request Date</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        ) : (
                            <div>
                                <h3><b>No Requests Yet</b></h3>
                                <NavLink to={"/maintenance/order/new"}>
                                    <button type="button" id="add-work-order" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill" autoComplete="off">Submit Request</button>
                                </NavLink>
                            </div>
                        )}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div class="row">
                        <div class="content">
                        {workOrders.length > 0 ? (
                            <BootstrapTable data={workOrders} options={options} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' hidden={isMobile} width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true } />
                                <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                                {/* <TableHeaderColumn dataField='title' dataFormat={this.formatLease} dataSort={ true }>Lease</TableHeaderColumn> */}
                                <TableHeaderColumn dataField='property_name' dataFormat={this.formatPropertyName} dataSort={ true }>Property</TableHeaderColumn>
                                {/* <TableHeaderColumn dataField='building_name' dataFormat={this.formatBuildingLink} dataSort={ true }>Building</TableHeaderColumn> */}
                                <TableHeaderColumn dataField='assignee_name' dataFormat={this.formatContractorLink} dataSort={ true }>Assigned</TableHeaderColumn>
                                <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Submitted</TableHeaderColumn>
                                <TableHeaderColumn dataAlign='center' width="100" dataFormat={this.formatActionOptions} />
                            </BootstrapTable>
                        ) : (
                            <p>No maintenance requests.</p>
                        )}
                        </div>
                        <div class="content">
                            <NavLink to={"/maintenance/order/new"}>
                                <button type="button" id="add-work-order" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off">Add Request</button>
                                <div class="clearfix"></div>
                            </NavLink>
                        </div>
                    </div>
                )
            }
        } else if(this.props.tableType != 'widget'){
            return (
                <div class="row">
                    <div class="content">
                    {workOrders.length > 0 ? (
                        <BootstrapTable data={workOrders} version='4' options={options} striped search pagination>
                            <TableHeaderColumn dataField='id' hidden={isMobile} width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true } />
                            <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                            <TableHeaderColumn dataField='building_name' dataFormat={this.formatPropertyName} dataSort={ true }>Property</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Submitted</TableHeaderColumn>
                            <TableHeaderColumn dataAlign='center' width="100" dataFormat={this.formatActionOptions} />
                        </BootstrapTable>
                    ) : (
                        <p>No maintenance requests.</p>
                    )}
                    </div>
                    <div class="content">
                        <NavLink to={"/maintenance/order/new"}>
                            <button type="button" id="add-work-order" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off">Add Request</button>
                            <div class="clearfix"></div>
                        </NavLink>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="row">
                    <div class="content">
                    {workOrders.length > 0 ? (
                        <BootstrapTable data={workOrders} striped version='4' height="380px">
                            <TableHeaderColumn hidden={isMobile} width="50" dataField='id' options={options} columnClassName="table-index" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true } />
                            <TableHeaderColumn dataField='work_order_title' dataFormat={this.clickableTitle} dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.simpleFormatSubmittedDate} dataSort={ true }>Created</TableHeaderColumn>
                        </BootstrapTable>
                    ) : (
                        <p>No maintenance requests.</p>
                    )}
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrders/TenantWorkOrdersList.jsx